export default __webpack_public_path__ + "static/digital-success-cefbf83f1c6688c41e49db3fdff6e172.png";